import styled from "@emotion/styled";

export enum TEXT_VARIANTS {
  T12 = `
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    font-family: "SF Pro";
    letter-spacing: -0.02em;
  `,
  T15CAPS = `
    font-weight: 700;
    font-size: 15px;
    line-height: 25px;
    font-family: "SF Pro Rounded";
    letter-spacing: 0.01em;
  `,
  T20 = `
    font-weight: 400;
    font-size: 20px;
    line-height: 25px;
    letter-spacing: -0.02em;
  `,
  T20SEMIBOLD = `
    font-weight: 600;
    font-size: 20px;
    line-height: 25px;
    letter-spacing: -0.02em;
  `,
  T20BOLD = `
    font-weight: 700;
    font-size: 20px;
    line-height: 25px;
    letter-spacing: -0.02em;
  `,
  T25 = `
    font-weight: 700;
    font-size: 25px;
    line-height: 25px;
    letter-spacing: -0.01em;
  `,
  T30 = `
    font-weight: 700;
    font-size: 30px;
    line-height: 30px;
    letter-spacing: -0.01em;
  `,
  T30SOFT = `
    font-weight: 800;
    font-size: 30px;
    line-height: 25px;
    font-family: "SF Pro Rounded";
    letter-spacing: -0.04em;
  `,
}

export const Text = styled.div<{ variant: TEXT_VARIANTS }>`
  ${({ variant }) => variant}
`;
